import React from 'react';
import Lottie from 'react-lottie';
import animationData from './inkit_loader.json';
import { Box } from "@mui/material";

const LottieLoader = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData, // Your imported Lottie animation JSON
    };

    return (
        <Box>
            <Lottie height={300}
                width={300}
                options={defaultOptions} />
        </Box>
    );
};

export default LottieLoader;